import { render, staticRenderFns } from "./FormPhoneInput.vue?vue&type=template&id=952044c0&"
import script from "./FormPhoneInput.vue?vue&type=script&lang=js&"
export * from "./FormPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports